export interface FunnelNavItem {
  id: number;
  isComplete: boolean;
  key: string;
  link?: boolean;
  redirect?: string | null;
}

export enum BaseFunnelQuestion {
  PositionDesired = 'PositionDesired',
}

export interface BaseFunnelJobTitle {
  id: string;
  title: string;
}

export type FunnelJobTitleAnswer<J extends BaseFunnelJobTitle = BaseFunnelJobTitle> = { jobTitle: J; question: string };

export type BaseFunnelAnswers<J extends BaseFunnelJobTitle = BaseFunnelJobTitle> = Partial<{
  [BaseFunnelQuestion.PositionDesired]: FunnelJobTitleAnswer<J>[];
  [key: string]: unknown;
}>;

export type LocalFunnelStep<
  J extends BaseFunnelJobTitle = BaseFunnelJobTitle,
  A extends BaseFunnelAnswers<J> = BaseFunnelAnswers<J>,
  Q extends string = string,
  P = undefined,
> = {
  category: string;
  /**
   * If defined returns whether the current step should be shown.
   * Defaults to true.
   */
  condition?: (answers: A, jobTitles: J[], props: P) => boolean;
  /**
   * Returns the job title the candidate needs to be updated to.
   */
  getNewJobTitle?: (answer: NonNullable<A[Q]>, answers: A, jobTitles: J[], props?: P | unknown) => J | J[] | null;
  key: Q;
  /**
   * A default value for the question
   */
  defaultValue?: A[Q];
  /**
   * Show question even if it is answered an existing answer
   */
  conditionOveride?: (answers: A, jobTitles: J[], props: P) => boolean;
};

export type AnswerCallback<Q = string> = (questionId: Q, category: string, answer: unknown, answers?: BaseFunnelAnswers) => void;

export type OnFunnelAnswer = (answer?: unknown) => void;

export type ConditionalStep<Step, O> = (options?: O & { isMultiposting?: boolean }) => Step;
